import SecurityService from "@security/Services/SecurityService";

export const axiosInstance = SecurityService.createAxiosInstance("/api/MediaItemsApi/");
